<main>
    <!-- <app-header></app-header> -->
    <!-- Research Statistics -->
    <div class="color-line"></div>
    <router-outlet></router-outlet>
    <!-- <app-footer></app-footer> -->
  </main>